export interface BlogConfig {
  lang: string;
  name: string;
  api?: string;
  apiType: "albina" | "blogger" | "wordpress";
  regions: string[];
  params: {
    id: string;
  };
}

export function mappedCategoryName(name: string): string {
  const categoryNameMap = window.config.categoryNameMap ?? {};
  return categoryNameMap[name] || name;
}
